/**
 * This is the key that must be set to "1" in LocalStorage to prevent
 * data from being sent to Analytics in a development instance
 * @constant
 */
export const DEV_MODE_KEY = 'dev_mode';

/**
 * Google Analytics 4 Measurement ID
 * GA4 uses this ID to track data from this app with its system
 * @constant
 */
export const GA_TRACKING_ID = 'G-K2FHGG3XGF';
